module.exports = __webpack_public_path__ + "e40d0eccf93dbe250de9c22058d9daea.svg";